import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full px-6 py-6 md:py-10 text-center max-w-4xl mx-auto" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} data-id="element-17">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-['Playfair_Display'] font-bold text-[#1B2A4A] leading-tight mb-3" data-id="element-18">
          Apagar el celular no debería terminar en discusiones
        </h1>
        <p className="text-lg md:text-xl text-[#3D3D3D] max-w-2xl mx-auto leading-relaxed" data-id="element-19">
          Un sistema simple para ordenar el uso de celulares en casa, incluso
          cuando estás cansado.
        </p>
        <p className="text-sm md:text-base text-[#7A7A7A] mt-3 max-w-2xl mx-auto" data-id="element-20">
          Usado por familias que necesitaban orden, no más peleas.
        </p>
      </motion.div>
    </section>;
}